import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthLayout, FormError, authButton, authInput } from "@/components/auth/AuthLayout";
import { api } from "@/lib/api";

export default function SignUp() {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 8) return setError("Use at least 8 characters for your password.");
    setBusy(true);
    try {
      const res = await api.post("/auth/signup", { display_name: name.trim(), email: email.trim(), password }, { auth: false });
      navigate("/check-email", { state: { email: email.trim(), pending: res?.status === "email_pending" } });
    } catch (err) {
      setError(err.code === "invalid_request" ? "Please check your name and email address." : err.message);
      setBusy(false);
    }
  };

  return (
    <AuthLayout
      testId="sign-up-page"
      title="Create your account"
      subtitle="Chat, search and create with ChatSleek."
      footer={
        <>
          Already have an account?{" "}
          <Link to="/sign-in" className="text-white underline-offset-4 hover:underline" data-testid="signup-login-link">
            Sign in
          </Link>
        </>
      }
    >
      <form onSubmit={submit} className="space-y-3.5">
        <input required maxLength={80} autoComplete="name" placeholder="Your name" value={name} onChange={(e) => setName(e.target.value)} className={authInput} data-testid="signup-name-input" />
        <input type="email" required autoComplete="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className={authInput} data-testid="signup-email-input" />
        <input type="password" required minLength={8} maxLength={72} autoComplete="new-password" placeholder="Password (8+ characters)" value={password} onChange={(e) => setPassword(e.target.value)} className={authInput} data-testid="signup-password-input" />
        <FormError>{error}</FormError>
        <button type="submit" disabled={busy} className={authButton} data-testid="signup-submit-button">
          {busy ? "Creating account…" : "Create account"}
        </button>
        <p className="text-center text-xs text-zinc-600">We'll email you a link to verify your address before you can sign in.</p>
      </form>
    </AuthLayout>
  );
}
